module.exports = __webpack_public_path__ + "img/mecca.09b7559c.png";